import { SVGProps } from '@components/Icon/types';

export const ResetAxes = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    {/* Circular refresh arrow, positioned upper-right */}
    <g transform="translate(7, 4) scale(0.9848)">
      <path
        d="M6.59997 0.1C3.01683 0.1 0.1 3.01684 0.1 6.6C0.1 10.1832 3.01683 13.1 6.59997 13.1C10.1831 13.1 13.0999 10.1832 13.0999 6.6C13.101 6.5251 13.0872 6.45074 13.0592 6.38124C13.0313 6.31173 12.9898 6.24847 12.9373 6.19513C12.8847 6.14179 12.822 6.09944 12.7529 6.07053C12.6838 6.04162 12.6096 6.02673 12.5347 6.02673C12.4598 6.02673 12.3857 6.04162 12.3166 6.07053C12.2475 6.09944 12.1848 6.14179 12.1322 6.19513C12.0796 6.24847 12.0382 6.31173 12.0102 6.38124C11.9823 6.45074 11.9685 6.5251 11.9695 6.6C11.9695 9.57223 9.57219 11.9696 6.59997 11.9696C3.62775 11.9696 1.23043 9.57223 1.23043 6.6C1.23043 3.62777 3.62775 1.23043 6.59997 1.23043C8.14747 1.23043 9.5368 1.8827 10.5156 2.92609H9.42605C9.35115 2.92503 9.27679 2.93886 9.20728 2.96679C9.13778 2.99472 9.07452 3.03619 9.02118 3.08878C8.96784 3.14137 8.92549 3.20404 8.89658 3.27314C8.86767 3.34224 8.85278 3.4164 8.85278 3.4913C8.85278 3.56621 8.86767 3.64037 8.89658 3.70947C8.92549 3.77857 8.96784 3.84124 9.02118 3.89383C9.07452 3.94642 9.13778 3.98788 9.20728 4.01581C9.27679 4.04374 9.35115 4.05758 9.42605 4.05652H12.5347V0.947826C12.5358 0.872253 12.5216 0.79724 12.4932 0.727224C12.4647 0.657208 12.4225 0.59361 12.369 0.540193C12.3156 0.486776 12.2519 0.444623 12.1819 0.416229C12.1118 0.387834 12.0368 0.373775 11.9612 0.374881C11.8114 0.377077 11.6686 0.438656 11.5642 0.546088C11.4598 0.65352 11.4022 0.798016 11.4043 0.947826V2.22674C10.2147 0.921459 8.50126 0.1 6.59997 0.1Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
    </g>
    {/* L-shaped axis corner, positioned lower-left, flipped */}
    <g transform="translate(3.5, 4.5) translate(0, 8) scale(1, -1) translate(0, -8) scale(0.9195)">
      <path
        d="M16.7 0.7H1.7C1.14772 0.7 0.7 1.14772 0.7 1.7V16.7"
        stroke={fill}
        strokeWidth="1.4"
        strokeLinecap="round"
        fill="none"
      />
    </g>
  </svg>
);

export const ICON_NAME = 'reset-axes';
